import OfferCalloutBadge from "@/app/components/ui/Badges/OfferCalloutBadge";

export const ItemTile = ({ index, item, hasMembership }) => {
  return (
    <div className="min-h-[96px] relative grid grid-cols-[2fr_1fr_1fr_1fr_1fr] mt-[10px] items-center p-4 pr-2 border border-[#D5D5D5] rounded-[20px] px-[24px]">
      <div className="flex gap-3 items-center min-w-0">
        <p className="text-[24px] shrink-0">{index}.</p>

        <div className="flex w-[500px] shrink-0 flex-col gap-1">
          <p className="text-[24px] overflow-hidden text-ellipsis whitespace-nowrap">{item.name}</p>
          {/* Gift line: the gift's tag, as on the check-in screens */}
          {item?.gift_id && item?.offer_callout && <OfferCalloutBadge callout={item.offer_callout} size="large" />}
        </div>
      </div>
      <p className="text-[24px] text-center font-monoNums ml-52"> {item.qty || item.quantity}</p>
      <div className="flex justify-end items-center text-[24px] font-monoNums tabular-nums">
        <span className="text-right">
          <span className="mr-0.5">₹</span>
          {Math.floor(Number(item.unit_price))}
        </span>
      </div>
      <div className="flex flex-col items-right ml-16 tabular-nums">
        <span className="text-[24px] font-semibold font-monoNums text-right whitespace-nowrap">
          <span className="mr-0.5">₹</span>
          {Math.floor(Number(item.net_price))}
        </span>
        {Number(item.discount_amount) > 0 && (
          <span className="text-[18px] text-[rgba(131,131,134,1)] font-medium font-monoNums text-right line-through whitespace-nowrap">
            <span className="mr-0.5">₹</span>
            {Math.floor(Number(item.gross_price))}
          </span>
        )}
      </div>
      {Number(item.discount_amount) > 0 && (
        <div
          className={`font-semibold font-monoNums
    flex flex-col items-center w-fit ml-auto ${hasMembership ? "mr-3" : "mr-8"}`}
        >
          <span className="flex items-center text-[24px] text-[#149463]">
            <span className="mr-0.5">₹</span>
            {Math.floor(Number(item.discount_amount))}
          </span>
          <span className="text-[18px] font-medium bg-[#E6FFDC] text-[#149463] rounded-[20px] pt-[5px] pr-[10px] pl-[10px] pb-[5pxs]  ">
            {item.discount_rate % 1 !== 0 ? Number(item.discount_rate).toFixed(1) : item.discount_rate}% Off
          </span>
        </div>
      )}
    </div>
  );
};
